var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 58 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.255 30.212v-17.09L48.62 20.77v33.2l5.473-3.136a7.73 7.73 0 0 0 3.91-6.712V19.877a7.73 7.73 0 0 0-3.91-6.712L32.91 1.039a7.87 7.87 0 0 0-7.818 0l-2.346 1.342v20.667L29 26.63l6.255 3.581zM3.91 50.836 25.09 62.96a7.88 7.88 0 0 0 7.82 0l2.344-1.342V40.952l-6.255-3.581-6.256-3.581v17.09L9.38 43.232V10.029l-5.474 3.136A7.74 7.74 0 0 0 0 19.877v24.245a7.74 7.74 0 0 0 3.91 6.712z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h58v64H0z"
  })))));
};
export default SvgLogo;